module.exports = __webpack_public_path__ + "img/body-2.083a3dd9.png";